<template>
  <div class="app_detail_container">
    <PageTitle
      :title="title"
      :showFileBtn="true"
      backPath="AppQuotationApply"
      :menuArgs="menuArgs"
      @clickFileBtn="clickFileBtn"
    />
    <div class="app_menu_main">
      <PageDetailDivider ref="PageDetailDividerRef" title="主表信息" />
      <div class="app_menu_main_form">
        <el-form :rules="rules" :model="form">
          <el-form-item label="企业名称" prop="customer_name">
            <el-input placeholder="关联获取" readonly v-model="form.customer_name" />
          </el-form-item>
          <el-form-item label="项目名称" prop="project_name">
            <el-input placeholder="关联获取" readonly v-model="form.project_name" />
          </el-form-item>
          <el-form-item label="需求日期" prop="requirement_date">
            <el-input placeholder="关联获取" v-date readonly v-model="form.requirement_date" />
          </el-form-item>
          <el-form-item label="需求概述" prop="requirement_content">
            <el-input type="textarea" :rows="3" placeholder="关联获取" readonly v-model="form.requirement_content" />
          </el-form-item>
          <el-form-item label="内部价格(元)" prop="proposal_quotation">
            <el-input placeholder="关联获取" v-appmoney:2="showMoney" readonly v-model="form.proposal_quotation" />
          </el-form-item>
          <el-form-item label="对外报价(元)" prop="outward_quotation">
            <el-input placeholder="关联获取" v-appmoney:2="showMoney" readonly v-model="form.outward_quotation" />
          </el-form-item>
          <el-form-item label="审批报价(元)" prop="final_quotation" v-if="form.document_status === 9">
            <el-input placeholder="关联获取" v-appmoney:2="showMoney" readonly v-model="form.final_quotation" />
          </el-form-item>
          <el-form-item label="总经理审批意见" prop="president_approve_opinions" v-show="form.document_status > 1">
            <el-input type="textarea" :rows="5" readonly v-model="form.president_approve_opinions" />
          </el-form-item>
          <el-form-item label="领导审批意见" prop="leader_approve_opinions" v-show="form.document_status > 1">
            <el-input type="textarea" :rows="5" readonly v-model="form.leader_approve_opinions" />
          </el-form-item>
          <el-form-item label="建设周期" prop="construction_period">
            <el-input placeholder="关联获取" readonly v-model="form.construction_period" />
          </el-form-item>
          <el-form-item label="备注" prop="memo">
            <el-input type="textarea" :rows="3" placeholder="关联获取" readonly v-model="form.memo" />
          </el-form-item>
        </el-form>
      </div>
      <PageDetailDivider title="明细信息" />

      <div class="no-detail-data" v-if="form.detailList.length === 0">
        - 没有明细数据 -
      </div>

      <div class="bottom-detail">
        <div class="detail" v-for="(item, index) of form.detailList" :key="index">
          <div class="detail-item">
            <span>需求内容：</span>
            {{ item.requirement_content }}
          </div>
          <div class="detail-item">
            <span>需求点：</span>
            {{ item.features }}
          </div>
          <div class="detail-item db-detail-item detail-item-left">
            <span>开发工时：</span>
            {{ item.dev_hours }}
          </div>
          <div class="detail-item db-detail-item">
            <span>报价开发工时：</span>
            {{ item.quoted_dev_hours }}
          </div>
          <div class="detail-item db-detail-item detail-item-left">
            <span>测试工时：</span>
            {{ item.testing_hours }}
          </div>
          <div class="detail-item db-detail-item">
            <span>报价测试工时：</span>
            {{ item.quoted_testing_hours }}
          </div>
          <!-- db-detail-item detail-item-left -->
          <div class="detail-item">
            <span>开发合计工时：</span>
            {{ item.dev_hours_sum }}
          </div>
          <!-- db-detail-item -->
          <div class="detail-item">
            <span>报价合计工时：</span>
            {{ item.quoted_hours_sum }}
          </div>
          <div class="detail-item">
            <span>单价：</span>
            {{ item.price }}
          </div>
          <div class="detail-item">
            <span>内部报价金额: </span>
            {{ $utils.commafy(item.quoted_amount, { digits: 2 }) }}
          </div>
          <div class="detail-item">
            <span>备注：</span>
            {{ item.memo }}
          </div>
        </div>
      </div>
    </div>

    <PageDetailBtns
      ref="PageDetailBtnsRef"
      menuPath="QuotationApply"
      :parentData="this"
      :refuseLabel="'驳回'"
      @handleClick="handleClickBtn"
    />
    <!-- 附件 -->
    <PageDetailFile ref="PageDetailFileRef" :ID="id" vuePath="QuotationApply" />

    <FastInputVue
      ref="FastInputVueRef"
      :isMobile="true"
      :modalTitle="fastInputType === 'refuse' ? '驳回' : '审批'"
      @sureBack="sureBackApprovalOpinions"
    />
    <FastInputFinal ref="FastInputFinalRef" :isMobile="true" @sureBack="sureBackApprovalFinalOpinions" />

    <!-- 确认dialog -->
    <ConfirmModal ref="ConfirmModalRef" @confirm="sureConfirm" />
  </div>
</template>
<script>
import PageTitle from '@/components/app/PageHeader.vue'
import PageDetailBtns from '@/components/app/PageDetailBtns.vue'
import PageDetailDivider from '@/components/app/PageDetailDivider.vue'
import PageDetailFile from '@/components/app/PageDetailFile.vue'
import FastInputVue from '@/components/Modal/FastInput/FastInput.vue'
import ConfirmModal from '@/components/app/ConfirmModal.vue'
import FastInputFinal from '../../../QuotationApply/FastInput.vue'

export default {
  components: {
    PageTitle,
    PageDetailBtns,
    PageDetailDivider,
    PageDetailFile,
    ConfirmModal,
    FastInputVue,
    FastInputFinal
  },
  data() {
    return {
      id: -1,
      title: '报价明细',
      formVisible: false,
      // 表单
      form: {
        id: 0,
        manager_review: true,
        creator_id: 0,
        creator: '',
        createTime: '',
        dept_name: '',
        customer_name: '',
        project_name: '',
        construction_period: '',
        memo: '',
        requirement_date: '',
        requirement_content: '',
        proposal_quotation: 0,
        outward_quotation: 0,
        president_approve_opinions: '',
        leader_approve_opinions: '',
        final_quotation: 0,
        document_status: 0,
        last_modify_time: '',
        timeLine: [],
        detailList: []
      },
      rules: {
        customer_name: [
          { required: true, message: '请输入企业名称', trigger: 'change' },
          {
            min: 0,
            max: 128,
            message: '长度在 0 到 128 个字符',
            trigger: 'change'
          }
        ],
        requirement_date: [{ required: true, message: '请输入需求日期', trigger: 'change' }],
        requirement_content: [{ required: true, message: '请输入需求内容', trigger: 'change' }],
        proposal_quotation: [
          // { required: true, message: '请输入建议报价(元)', trigger: 'change' },
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.greaterThanZero,
            length: 12,
            decimalLength: 2,
            trigger: 'change'
          }
        ]
      },
      // 展示金额
      showMoney: true,
      menuArgs: '',
      // 快速输入框类型
      fastInputType: ''
    }
  },
  mounted() {
    this.id = this.$route.query.id

    this.BindText()

    this.menuArgs = this.$route.query.menuArgs
  },
  methods: {
    // 最终节点输入完意见
    async sureBackApprovalFinalOpinions(options) {
      const { final_quotation, ApprovalOpinions } = options
      const flag = await this.sureReview(false, ApprovalOpinions, final_quotation)

      if (flag) {
        this.$message.success('操作成功!')

        this.$emit('updateData')
        this.BindText()

        this.$refs.FastInputFinalRef.closeModal()
      }
    },
    // 输入完意见
    async sureBackApprovalOpinions(options) {
      if (this.fastInputType === 'refuse') {
        const flag = await this.sureObsolete(options)

        if (flag) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()

          this.$refs.FastInputVueRef.closeModal()
        }
      } else {
        const flag = await this.sureReview(false, options)

        if (flag) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()

          this.$refs.FastInputVueRef.closeModal()
        }
      }
    },
    // 确认
    async sureConfirm(code) {
      if (code === 'refuse') {
        const success = await this.sureObsolete()
        if (success) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()
        }
      } else if (code === 'unReview') {
        const success = await this.sureUnReview()
        if (success) {
          this.$message.success('取消成功!')

          this.$emit('updateData')
          this.BindText()
        }
      }
    },
    // 领导/总经理审批
    refuse() {
      this.fastInputType = 'refuse'
      this.$refs.FastInputVueRef.openModal()
    },
    // 领导/总经理审批
    leaderReview() {
      // 林工审过了, 到姚总审, 可以改最终报价
      if (this.form.document_status === 2) {
        this.$refs.FastInputFinalRef.openModal(this.form.outward_quotation)
      } else {
        this.fastInputType = 'review'
        this.$refs.FastInputVueRef.openModal()
      }
    },
    // 取消审核
    unReview() {
      this.$confirm('是否确认取消?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureUnReview()
        if (success) {
          this.$message.success('取消成功!')

          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    // 调用审批接口
    async sureReview(flag = false, options = '', final_quotation = 0) {
      const { data: res } = await this.$http.put('/Finance/Quotation_apply/audit', [
        {
          id: this.id,
          manager_review: flag,
          approve_opinions: options,
          final_quotation
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 调用撤销审核
    async sureUnReview(flag = false) {
      const { data: res } = await this.$http.put('/Finance/Quotation_apply/unaudit', [
        {
          id: this.id,
          manager_review: flag
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 调用拒绝接口
    async sureObsolete(options) {
      const { data: res } = await this.$http.put('/Finance/Quotation_apply/obsolete', [
        {
          id: this.id,
          manager_review: false,
          approve_opinions: options
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 点击底部按钮
    handleClickBtn(code) {
      switch (code) {
        case 'save':
          this.save()
          break
        case 'del':
          this.del()
          break
        case 'unReview':
          // this.unReview()
          this.$refs.ConfirmModalRef.openDialog('unReview')

          break
        case 'managerReview':
        case 'leaderReview':
          this.leaderReview()
          // this.$refs.FastInputVueRef.openModal()
          break
        case 'refuse':
          this.refuse()
          break
        case 'close':
          this.formVisible = false
          break
      }
    },
    // 绑定数据
    async BindText() {
      const that = this
      const { data: res } = await that.$http.get('/Finance/Quotation_apply', {
        params: {
          id: that.id
        }
      })
      if (res.isSuccess) {
        that.form = res.data
      }
    },
    // 点击附件按钮
    clickFileBtn() {
      this.$refs.PageDetailFileRef.openDialog()
    }
  }
}
</script>
<style lang="less" scoped>
@headerHeight: 50px;

// 没有明细数据时的展示
.no-detail-data {
  height: 80px;
  color: #bbbbbb;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bottom-detail {
  // 明细表
  .detail {
    display: flex;
    flex-wrap: wrap;
    padding: 10px;
    padding-bottom: 0;
    border-bottom: 1px solid #d4d5d7;
    margin-bottom: 10px;
    position: relative;

    .db-detail-item {
      width: 40% !important;
    }

    .detail-item-left + .db-detail-item {
      width: 45% !important;
    }

    .detail-item {
      margin: 5px;
      width: 90%;
      font-size: 18px;

      > span {
        color: #888888;
      }
    }
  }
}

.app_detail_container {
  width: 100vw;
  height: 100vh;

  .app_menu_main {
    height: calc(100% - @headerHeight);
    width: 100%;
    // background-color: #fafafa;

    overflow: auto;

    box-sizing: border-box;
    // padding: 0 20px;
    // padding-top: 10px;
    // padding-bottom: 20px;

    /deep/ .el-form-item__label {
      padding: 0 !important;
      font-size: 20px !important;
      font-weight: 500;
      color: #a78897;
    }
    /deep/ .el-input__inner {
      border: 0 !important;
      border-bottom: 1px solid #d1d1d1 !important;
      border-radius: 0;
      padding-left: 0 !important;
      transition: all 0.3s;
      // background-color: #fafafa;
      font-size: 18px !important;
    }

    /deep/ .el-textarea__inner {
      font-size: 18px !important;
    }

    // /deep/ .el-input__inner:hover {
    //   padding-left: 10px !important;
    //   transition: all 0.3s;
    // }
    /deep/ .el-input__inner:focus {
      padding-left: 10px !important;
      transition: all 0.3s;
    }

    .app_menu_main_form {
      box-sizing: border-box;
      padding: 0 20px 20px 20px;
    }
  }
}
.file-list-container {
  // box-sizing: border-box;
  padding: 10px;

  height: 30px;
}
</style>
